import { MigrationInfo } from '../types'
import { determineApyImprovement } from './determineApyImprovement'
import { SPARK_VAULTS_V2_ENABLED } from '@/config/chain/flags'
import { OpenDialogFunction } from '@/domain/state/dialogs/slice'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { upgradeSdaiDialogConfig } from '@/features/savings/dialogs/upgrade-sdai/UpgradeDialog'
import { upgradeSusdcDialogConfig } from '@/features/savings/dialogs/upgrade-susdc/UpgradeSusdcDialog'
import { SavingsAccountRepository } from '@/features/savings/logic/savings-converters/types'

export interface MakeMigrationInfoParams {
  selectedAccount: TokenSymbol
  savingsAccounts: SavingsAccountRepository
  openDialog: OpenDialogFunction
}

export function makeMigrationInfo({
  selectedAccount,
  savingsAccounts,
  openDialog,
}: MakeMigrationInfoParams): MigrationInfo | undefined {
  if (selectedAccount === TokenSymbol('sDAI')) {
    const sdaiAccount = savingsAccounts.findBySavingsTokenSymbol(TokenSymbol('sDAI'))
    const susdsAccount = savingsAccounts.findBySavingsTokenSymbol(TokenSymbol('sUSDS'))

    if (!sdaiAccount || !susdsAccount) {
      return undefined
    }

    return {
      type: 'sdai-to-susds',
      apyImprovement: determineApyImprovement({
        savingsUsdsConverter: susdsAccount.converter,
        savingsDaiConverter: sdaiAccount.converter,
      }),
      openSDaiToSUsdsUpgradeDialog: () => {
        openDialog(upgradeSdaiDialogConfig, {})
      },
    }
  }

  if (SPARK_VAULTS_V2_ENABLED && selectedAccount === TokenSymbol('sUSDC')) {
    const spusdcAccount = savingsAccounts.findBySavingsTokenSymbol(TokenSymbol('spUSDC'))
    if (!spusdcAccount) {
      return undefined
    }

    return {
      type: 'susdc-to-spusdc',
      openSusdcToSpusdcUpgradeDialog: () => {
        openDialog(upgradeSusdcDialogConfig, {})
      },
    }
  }

  return undefined
}
